import { Link } from "gatsby";
import React from "react"
import '../styles/global.css';
import HeaderNav from './HeaderNav';
import Seo from "./Seo";


const Footer = ()=>{
    return(
        <div className="flex items-center mt-64  w-full bg-black text-white  ">
            <div className="flex items-center max-w-5xl w-full justify-between mx-auto text-base sm:text-lg  px-4 py-6 sm:px-6 md:px-8 lg:px-12 xl:px-16 justify-between">
                <div className="text-base sm:text-lg ">
                    Keepit | 2021
                </div>
                <div className="text-base sm:text-lg flex  items-center justify-center gap-8">
                    <Link to="/pricing">Pricing</Link>
                    <Link to="/contact">Contact</Link>
                </div>
                
            </div>
            
        </div>
    )
}
const Layout = ({children,location}) => {
    return ( 
        <div className="flex flex-col min-h-screen justify-between">
            <HeaderNav location={location}/>
            <Seo/>
            {children}
            <Footer/>
        </div>
     );
}
 
export default Layout;